@if (isTableMode) {
  <thead>
    <tr>
      @for (column of columns; track column.field) {
        <th [class]="column.cssClass || 'text-primary-emphasis'">
          <div 
            class="dt-column-header table-column-sort" 
            [class.dt-ordering-asc]="getDirection(column.field) === 'asc'"
            [class.dt-ordering-desc]="getDirection(column.field) === 'desc'"
            (click)="onColumnSort(column)"
            role="button"
            tabindex="0"
            (keydown.enter)="onColumnSort(column)"
          >
            <span class="dt-column-title">{{ column.label }}</span>
            <span class="dt-column-order">
              @if (getDirection(column.field) === 'none') {
                <i class="mdi mdi-swap-vertical"></i>
              } @else if (getDirection(column.field) === 'asc') {
                <i class="mdi mdi-arrow-up"></i>
              } @else {
                <i class="mdi mdi-arrow-down"></i>
              }
            </span>
          </div>
        </th>
      }
    </tr>
  </thead>
} @else {
  <div 
    class="dt-column-header table-column-sort" 
    [class.dt-ordering-asc]="direction === 'asc'"
    [class.dt-ordering-desc]="direction === 'desc'"
    (click)="toggleSort()"
    role="button"
    tabindex="0"
    (keydown.enter)="toggleSort()"
    [attr.aria-label]="label + ': Ordenar'"
    [attr.aria-sort]="direction === 'asc' ? 'ascending' : direction === 'desc' ? 'descending' : 'none'"
  >
    <span class="dt-column-title">{{ label }}</span>
    <span class="dt-column-order">
      @if (direction === 'none') {
        <i class="mdi mdi-swap-vertical"></i>
      } @else if (direction === 'asc') {
        <i class="mdi mdi-arrow-up"></i>
      } @else {
        <i class="mdi mdi-arrow-down"></i>
      }
    </span>
  </div>
}